import { DateTime } from "luxon";

export interface LocalDateTime {
  localDate: string; // format: "dd/MM/yyyy"
  localTime: string; // format: "HH:mm"
}

/**
 * Converts a UTC timestamp to local timezone date and time.
 * 
 * @param utcTimestamp - format: "YYYY-MM-DDTHH:mm:ss.sssss" (ISO format)
 * @param timeZone - IANA time zone with optional UTC offset (e.g., "Asia/Dubai (UTC+04:00)" or just "Asia/Dubai")
 * @returns LocalDateTime with date in "dd/MM/yyyy" and time in "HH:mm" formats
 */
export function convertUTCToLocal(
  utcTimestamp: string,
  timeZone: string
): LocalDateTime {
  // Extract timezone name by removing the UTC offset part if present
  const cleanTimeZone = timeZone.split(' (')[0];
  
  const utcDateTime = DateTime.fromISO(utcTimestamp, { zone: "utc" });
  const localDateTime = utcDateTime.setZone(cleanTimeZone);

  return {
    localDate: localDateTime.toFormat("dd/MM/yyyy"),
    localTime: localDateTime.toFormat("HH:mm")
  };
}